module.exports = __webpack_public_path__ + "static/media/10 Slalom_eq 05-29.60632f6f.mp3";